import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BottomNavigationAction from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/BottomNavigationAction';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';
import { useCheckSelected } from 'Components/ClientApp/CombinedApp/Navigation/BottomNav/ActionCtx';
import { FDIcon } from '@facet-wealth/design';
import { pathMatches } from '../pathMatches';

const useStyles = buildUseStyles('Action', (theme) => ({
  label: {
    marginTop: theme.spacing(0.5),
    fontWeight: theme.typography.caption.fontWeight,
    fontSize: `${theme.typography.body2.fontSize} !important`, // Needed because when it's selected, MUI adds a more specific selector (like .label.selected)
  },
  badge: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const Action = ({
  label,
  onClick,
  to,
  badge,
  selectedIf,
  value,
  icon,
}) => {
  const classes = useStyles();
  const defaultSelectedIf = useMemo(() => (to ? pathMatches(to) : () => false), [to]);
  const selected = useCheckSelected(value, (selectedIf ?? defaultSelectedIf));

  const iconColor = selected ? 'primary' : 'textDisabled';
  const iconWithBadge = badge ? (
    <Badge badgeContent={badge.content} test={badge.test} classes={{ badge: classes.badge }}>
      <FDIcon icon={icon} color={iconColor} />
    </Badge>
  ) : <FDIcon icon={icon} color={iconColor} />;

  return (
    <BottomNavigationAction
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      disableRipple
      icon={iconWithBadge}
      classes={{
        label: classes.label,
      }}
      label={label}
      showLabel
      selected={selected}
      data-selected={selected.toString()}
      data-test={`bottom-navigation-action-${value}`}
    />
  );
};

Action.defaultProps = {
  onClick: undefined,
  to: undefined,
  badge: undefined,
  selectedIf: undefined,
};
Action.propTypes = {
  label: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  value: PropTypes.string.isRequired,
  selectedIf: PropTypes.func,
  badge: PropTypes.shape({
    content: PropTypes.node.isRequired,
    test: PropTypes.string,
  }),
};
